import IMAGES from '../images';
import './ProduitEntretien.css';

export default function ProduitEntretien() {
  return (
    <main className="cpage entretien-page">
      {/* Universal Banner */}
      <div className="cpage__banner">
        <img src={IMAGES.entretien[0]} alt="Soin du Laiton" className="cpage__banner-img" />
        <div className="cpage__banner-overlay" />
        <div className="cpage__banner-content">
          <span className="section-label">Soin du Laiton</span>
          <h1 className="cpage__banner-title">Produits d'Entretien</h1>
          <div className="cpage__banner-divider" />
          <p className="cpage__banner-desc">
            Préservez la brillance et la splendeur originelle de vos créations artisanales en laiton massif.
          </p>
        </div>
      </div>

      <div className="entretien-page__content">
        <div className="entretien-page__intro">
          <h2 className="serif">Le Produit Miracle d'Entretien</h2>
          <p>
            Chaque pièce Khansa Yazidi est sculptée dans du laiton massif de la plus haute qualité. 
            Afin de vous aider à préserver l'éclat chaleureux de ce matériau noble à travers les années, 
            nous vous offrons une boîte de notre <strong>Pâte Miracle d'Entretien</strong> pour tout achat d'une robinetterie.
          </p>
        </div>

        {/* Gallery */}
        <div className="entretien-page__gallery">
          {IMAGES.entretien.map((img, i) => (
            <div key={i} className="entretien-page__img-wrap">
              <img src={img} alt={`Produit d'entretien Khansa Yazidi - vue ${i + 1}`} />
            </div>
          ))}
        </div>

        {/* Directions */}
        <div className="entretien-page__directions">
          <span className="section-label" style={{ textAlign: 'center', display: 'block' }}>Guide d'utilisation</span>
          <h2 className="serif" style={{ textAlign: 'center', marginBottom: '2.5rem' }}>Comment utiliser la Pâte Miracle ?</h2>
          
          <div className="entretien-page__steps">
            <div className="entretien-page__step">
              <div className="entretien-page__step-num">01</div>
              <p><strong>Mouillez</strong> une éponge douce avec de l'eau et imbibez-la généreusement de produit miracle.</p>
            </div>
            
            <div className="entretien-page__step">
              <div className="entretien-page__step-num">02</div>
              <p><strong>Appliquez</strong> la pâte délicatement sur l'ensemble de la pièce en laiton en effectuant des mouvements circulaires.</p>
            </div>

            <div className="entretien-page__step">
              <div className="entretien-page__step-num">03</div>
              <p><strong>Laissez reposer</strong> quelques instants pour permettre aux agents actifs de désoxyder la surface et de restaurer le métal.</p>
            </div>

            <div className="entretien-page__step">
              <div className="entretien-page__step-num">04</div>
              <p><strong>Rincez</strong> abondamment à l'eau douce et séchez avec un chiffon propre et sec pour révéler la brillance.</p>
            </div>
          </div>

          <div className="entretien-page__note">
            <p>
              <strong>Note d'expert :</strong> Pour les taches particulièrement tenaces, vous pouvez utiliser une éponge métallique fine. 
              Veillez à toujours laisser sécher le produit à l'air libre avant de refermer soigneusement sa boîte protectrice.
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}
